<template>
  <div
    ref="menu-option-modal"
    class="menu-options-modal"
    :class="{ 'knowledgeAI-menu-options-modal': isKnowledgeAIEnabled }"
    tabindex="0"
  >
    <div class="menu-header">
      <div
        id="menu-heading"
        v-t="menuHeading"
        class="heading"
        :class="{ 'knowledgeAI-heading': isKnowledgeAIEnabled }"
        :style="{ ...getFontSizeForChatInterface('title') }"
      />
      <button
        class="tab-focused-btn"
        aria-label="close menu"
        @click="handleMenuClose()"
      >
        <div class="close-modal">
          <img :src="closeIcon" alt="close menu" />
        </div>
      </button>
    </div>
    <ul class="menu-options" aria-labelledby="menu-heading">
      <li v-for="(option, index) in options" :key="index" role="menuitem">
        <button
          v-t="option.label"
          class="tab-focused-btn menu-option"
          :class="{ 'knowledgeAI-menu-option': isKnowledgeAIEnabled }"
          :style="{ ...getFontSizeForChatInterface('bodyText') }"
          @click="quickMenuClickHandler(option, index)"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { focusOnChatInputField } from '@/services/utils'
import { constantStrings } from '@/services/constants'
import AppWarn from '../../../services/errors/app-warns'
import fontSizeMixin from '@/mixins/fontSizeMixin'

export default {
  mixins: [fontSizeMixin],
  data() {
    return {
      showOptions: false
    }
  },
  computed: {
    isKnowledgeAIEnabled() {
      return this.$store.getters.isKnowledgeAiEnabled
    },
    isDisneyDemoBot() {
      return this.$store.state.widgetConfig?.brandGPT?.enable || false
    },
    options() {
      return this.$store.state.quickMenuState.options
    },
    closeIcon() {
      return `${this.$cdn}/images/close_icon.svg`
    },
    menuHeading() {
      return this.$store.state.quickMenuState.type
    },
    showQuickMenu() {
      return this.$store.state.quickMenuState.visible
    },
    isEventAnalyticsMP() {
      return this.$store.state.widgetConfig?.eventAnalyticsMP || false
    }
  },
  mounted() {
    this.$refs['menu-option-modal'].focus()
  },
  methods: {
    // cw-accessibility
    handleFocusChange(focusOnQuickMenu) {
      this.$nextTick(function () {
        focusOnQuickMenu
          ? document.getElementById('quick-menu-options-btn')?.focus()
          : focusOnChatInputField()
      })
    },
    quickMenuClickHandler(option, index) {
      if (this.isDisneyDemoBot) {
        this.handleEndChat()
        return
      }
      this.isEventAnalyticsMP &&
        this.$segment.global.sendEvent('quick_menu_click')
      this.$store.state.quickMenuClickHandler(option, index)
      this.handleMenuClose(false)
    },
    handleMenuClose(focusOnQuickMenu = true) {
      this.$store.dispatch('updateQuickMenuVisibility', false)
      this.handleFocusChange(focusOnQuickMenu)
    },
    handleEndChat() {
      try {
        // End Chat Logic
        this.$store.dispatch('endChat', {
          message: constantStrings.CHAT_ENDED,
          showSessionRestartGreeting: true,
          hideEndChatGreeting: true
        })
      } catch (err) {
        console.log(err.message)
        new AppWarn({
          name: 'EndChat',
          message: `Error while ending chat. ${err.message}`
        })
      } finally {
        this.handleMenuClose(false)
        this.$store.commit('CLEAR_CHATS')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css/theme.scss';
@import '@/styles/css/commonStyles.scss';
.menu-options-modal {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.11);
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
  @include border-radius(var(--radius-chat-inner-component));
  max-height: 350px;
  * {
    box-sizing: border-box;
  }
  .menu-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 8px 10px 16px;
    .heading {
      font-weight: 500;
      line-height: 22px;
      color: #000000;
      &.knowledgeAI-heading {
        font-weight: 500;
        line-height: 22px;
      }
    }
    .close-modal {
      cursor: pointer;
    }
  }
  .menu-options {
    overflow-y: auto;
    max-height: 305px;
    padding-left: 0;
    margin: 0;
    list-style: none;
    list-style-type: none;
    li::before {
      content: none;
    }
    .menu-option {
      list-style: none;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 10px 8px 10px 16px;
      width: 100%;
      height: 40px;
      background: #ffffff;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      color: var(--widget-primary-color);
      cursor: pointer;
      user-select: none;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      box-sizing: border-box;
      &.knowledgeAI-menu-option {
        line-height: 20px;
        color: #000000;
      }
    }
    .menu-option:hover {
      background: var(--button-links-hover-background-color);
    }
  }

  .menu-options-footer {
    padding: 16px 16px 32px 16px;
    .menu-options-btn {
      cursor: pointer;
      padding: 4px;
      border-radius: var(--radius-chat-header-icon);
      background-color: var(--widget-primary-background-color);
    }
    :deep(svg) {
      path {
        fill: var(--widget-primary-color);
      }
    }
  }

  @media screen and (min-width: 440px) {
    width: 60%;
    margin: 0 auto;
  }

  &.knowledgeAI-menu-options-modal {
    width: 75%;
    max-width: 956px;
    @media screen and (max-width: 1919px) {
      width: 100%;
    }
  }
}
</style>
